import React from "react";
import cn from "clsx";
import { ConfigurableFormElementConfig } from "../../types";
import FormElements from "./FormElements";
import { RenderElementProps } from "./FormElement";
import { DEFAULT_ELEMENTS } from ".";
import "./Group.css";

export interface GroupProps extends RenderElementProps {
  /**
   * The form elements' configuration to render within the group.
   */
  fields?: ConfigurableFormElementConfig[];
  inline?: boolean;
}

export default function Group({
  id,
  label,
  className,
  display = true,
  fields,
  formProps: { sharedState, errors, elements = DEFAULT_ELEMENTS, t },
  ...props
}: GroupProps) {
  // Nothing to render
  if (!label && (!fields || !fields.length)) {
    return null;
  }

  return (
    <div id={id} className={cn("group", className)} aria-hidden={!display}>
      {!!label && <h4 className="group-title">{label}</h4>}
      {!!fields && fields.length > 0 && (
        <div
          className={cn(
            !props.inline && "group-content",
            props.inline && "group-content-inline"
          )}
        >
          <FormElements
            sharedState={sharedState}
            fields={fields}
            errors={errors}
            elements={elements}
            t={t}
          />
        </div>
      )}
    </div>
  );
}

/**
 * Special flag to ensure that this component gets extra `formProps`
 * property passed through when rendering.
 */
Group.renderWithFormProps = true;
